import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth/reducer";
import users from "./users/reducer";
import homes from "./home/reducer";
import contact from "./contactus/reducer";
import restaurant from "./restaurant/reducer";
import casestudy from "./casestudy/reducer";

export default combineReducers({
  auth,
  users,
  homes,
  contact,
  restaurant,
  casestudy,
});
